<template>
    <div>
        <ContactNoSaveWindow @confirmNext="confirmNext"/>
        <SaveWindow :text="subscribed ? 'Письмо сохранено' : 'Черновик успешно сохранен'"/>
        <InvalidFileFormatWindow :types="currentTypes"/>
        <FileSizeErrorWindow :size="fileSize"/>
        <FileLoadErrorWindow />
        <VideoLengthErrorWindow/>
        <div class="layout">

            <div class="cabinet-page_bg"></div>
            <HeaderAuth/>
            <div class="cabinet-content-block-wrapper">
                <div class="cabinet-content-block">

                    <ClientNavigation/>
                    <div v-if="!locked" class="cabinet-content">
                        <div class="heading-wrapper">
                            <div class="title">
                                <router-link :to="{name: 'ClientMails'}" class="button-close">
                                    <CloseIcon/>
                                </router-link>
                                <span v-if="newMail">Новое письмо</span>
                                <div v-if="!newMail && subscribed" class="text">Редактировать письмо с&nbsp;подпиской
                                </div>
                                <div v-if="!newMail && !subscribed" class="text">Редактировать черновик</div>
                            </div>
                            <div v-if="!newMail && subscribed" class="status">Подписка оформлена</div>
                            <div v-if="!newMail && !subscribed" class="status">Черновик</div>
                        </div>
                        <div class="cabinet-content-inner">

                            <div v-if="newMail" class="cabinet-text">
                                <p>Напишите письмо своим близким. Мы убедимся, что они его получат, если с вами
                                    что-нибудь случится.</p>
                            </div>

                            <div class="form">

                                <div class="form-field-input-2"
                                     :class="{'error-field' : emailIncorrect}">
                                    <label>Кому&nbsp;*</label>
                                    <div class="field-input-wrapper">
                                        <vue-tags-input
                                            :class="{dev_tag_error: emailIncorrect}"
                                            v-model="email"
                                            :tags="emails"
                                            :add-on-key="[13, ',',' ']"
                                            :placeholder="getPlaceholder"
                                            @before-adding-tag="checkEmail"
                                            @tags-changed="newTags => {emails = newTags; isChanged = true;}"
                                            @adding-duplicate="addDuplicateEmail"
                                        />
                                        <div v-show="emailIncorrect" class="msg-form msg-error-field">Введите корректный
                                            email
                                        </div>
                                    </div>
                                </div>
                                <div class="form-field-input-2">
                                    <label>
                                        Социальные сети адресатов

                                        <div class="field-help-wrapper">
                                            <div class="field-help-icon">
                                                <HelpIcon/>
                                            </div>
                                            <span class="field-help-text">
                                        На случай, если мы не сможем связаться с&nbsp;адресатом по указанным контактам
                                    </span>
                                        </div>
                                    </label>
                                    <div class="field-input-wrapper">
                                        <vue-tags-input
                                            v-model="social"
                                            :tags="socials"
                                            :add-on-key="[13, ',',' ']"
                                            :max-tags="maxTags"
                                            :maxlength="maxLength"
                                            placeholder=""
                                            @tags-changed="socialInput"
                                            @adding-duplicate="addDuplicateSocial"
                                        />
                                    </div>
                                </div>

                                <div class="form-field-input-2"
                                     :class="{'error-field' : phoneError}"
                                >
                                    <label>Номер телефона получателя</label>
                                    <div class="field-input-wrapper">
                                        <vue-tel-input v-model="receiverPhone"
                                                       :wrapperClasses="{'dev_error_tel_input' : phoneError}"
                                                       placeholder="Введите номер телефона"
                                                       name="phone"
                                                       v-validate="'required'"
                                                       @input="phoneInput"
                                                       @country-changed="countryChanged"
                                                       @validate="phoneValidate"
                                                       ref="phoneNumber"
                                        ></vue-tel-input>
                                        <div v-show="phoneError" class="msg-form msg-error-field">
                                            Введите корректный номер телефона
                                        </div>
                                    </div>
                                </div>

                                <div class="form-field-input-2">
                                    <label>Тема письма&nbsp;*</label>
                                    <div class="field-input-wrapper">
                                        <input v-model="subject" @change="isChanged = true" type="text" required=""
                                               value="">
                                    </div>
                                </div>
                                <div class="form-field-input-2" style="height: 192px">
                                    <label>Текст письма</label>
                                    <div class="field-editor-wrapper">
                                        <div class="field-editor-inner">
                                            <quill-editor @change="quillChange" v-model="content"
                                                          :options="options">
                                            </quill-editor>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-field-input-2">
                                    <label>
                                        Отправить к&nbsp;дате

                                        <div class="field-help-wrapper">
                                            <div class="field-help-icon">
                                                <HelpIcon/>
                                            </div>
                                            <span class="field-help-text">
                                        В случае, если оплаты по письму все еще продолжат поступать, то за месяц до указанной даты вам на почту будет выслано письмо с просьбой изменить дату отправки. Письмо не будет отправлено до подтверждения вашей смерти
                                    </span>
                                        </div>

                                    </label>
                                    <div class="field-input-wrapper form-field-date">
                                        <div class="form-field-date-inner">
                                            <div class="vdp-datepicker">
                                                <div>
                                                    <datepicker :disabled-dates="disabledDates" v-model="sendDate"
                                                                :language="languages[language]" @input="isChanged = true"
                                                                :monday-first="true"
                                                                format="dd.MM.yyyy" placeholder="__.__.____"></datepicker>
                                                </div>
                                                <button @click="datepickerClear" class="button-clear-field">
                                                    <DeleteIcon />
                                                </button>
                                            </div>
                                        </div>
                                        <div class="msg-form">Заполняется в случае, если Вам нужно отправить<br> к
                                            конкретной дате в будущем
                                        </div>
                                    </div>
                                </div>


                                <section class="form-section form-wrap other-doc-list">

                                    <div class="form-field-input-2">
                                        <label>Документы

                                            <div class="field-help-wrapper">
                                                <div class="field-help-icon">
                                                    <HelpIcon/>
                                                </div>
                                                <span class="field-help-text">
                                                        Ваши файлы будут загружены на Google Диск и доступны только по ссылке, которая сформируется после оформления подписки.
                                                    </span>
                                            </div>
                                        </label>

                                        <div class="field-files-wrapper">
                                            <div class="files">
                                                <div v-for="doc in documents" class="file-item">
                                                    <div class="file-thumb">
                                                        <img v-if="doc.type === 'application/pdf'"
                                                             src="../img/attach-doc-pdf.svg">
                                                        <img src="../img/attach-doc-docx.svg">
                                                    </div>
                                                    <div class="file-name">{{ getFileName(doc.name) }}</div>
                                                    <div @click="delFile(doc, 'doc')" class="file-buttons">
                                                        <DeleteIcon/>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="field-file loading-file" v-show="loadingDoc">
                                                <div class="loading-progress">
                                                    <div class="loading-progress-bar" style="width: 42%"></div>
                                                    <div class="loading-percent">{{ uploadDocPercentage }}%</div>
                                                </div>
                                                <button @click="cancelRequest" class="button-del-file"
                                                        title="Отменить загрузку">
                                                    <DeleteIcon/>
                                                </button>
                                            </div>

                                            <div v-show="documents.length < 5" class="add-file-button" @click="loadDoc">
                                                <button class="button-nobg-icon add-other-doc">
                                                    <span class="icon"><PlusIcon/></span>
                                                    <span class="text">Добавить документ</span>
                                                </button>
                                                <input type="file" multiple class="dev_doc_input dev_file_input"
                                                       @change="addDoc($event)"
                                                       accept="application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                                            </div>

                                            <div class="msg-form">Можно добавить до 5 документов, размером не более 10
                                                мегабайт каждое
                                            </div>

                                        </div>
                                    </div>

                                </section>

                                <section class="form-section form-wrap other-doc-list">

                                    <div class="form-field-input-2">
                                        <label>Изображения

                                            <div class="field-help-wrapper">
                                                <div class="field-help-icon">
                                                    <HelpIcon/>
                                                </div>
                                                <span class="field-help-text">
                                                        Ваши файлы будут загружены на Google Диск и доступны только по ссылке, которая сформируется после оформления подписки.
                                                    </span>
                                            </div>
                                        </label>

                                        <div class="field-files-wrapper">
                                            <div class="field-files-list">
                                                <div class="files">
                                                    <div v-for="(img, index) in images" class="file-item">
                                                        <div class="file-thumb">
                                                            <img :src="imagesSrc[index]">
                                                        </div>
                                                        <div class="file-name">{{ getFileName(img.name) }}</div>
                                                        <div @click="delFile(img, 'img')" class="file-buttons">
                                                            <DeleteIcon/>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="field-file loading-file" v-show="loadingImg">
                                                    <div class="loading-progress">
                                                        <div class="loading-progress-bar" style="width: 42%"></div>
                                                        <div class="loading-percent">{{ uploadImgPercentage }}%</div>
                                                    </div>
                                                    <button @click="cancelRequest" class="button-del-file"
                                                            title="Отменить загрузку">
                                                        <DeleteIcon/>
                                                    </button>
                                                </div>
                                            </div>

                                            <div v-show="images.length < 5" class="add-file-button" @click="loadImg">
                                                <button class="button-nobg-icon add-other-doc">
                                                    <span class="icon"><PlusIcon/></span>
                                                    <span class="text">Добавить изображение</span>
                                                </button>
                                                <input type="file" multiple accept="image/jpeg, image/png"
                                                       class="dev_img_input dev_file_input"
                                                       @change="addImg($event)">
                                            </div>

                                            <div class="msg-form">Можно добавить до 5 документов, размером не более 10
                                                мегабайт каждое
                                            </div>

                                        </div>
                                    </div>

                                </section>

                                <section class="form-section form-wrap other-doc-list">
                                    <div class="form-field-input-2">
                                        <label>
                                            Видео

                                            <div class="field-help-wrapper">
                                                <div class="field-help-icon">
                                                    <HelpIcon/>
                                                </div>
                                                <span class="field-help-text">
                                                    Ваши файлы будут загружены на Google Диск и доступны только по ссылке, которая сформируется после оформления подписки.
                                                </span>
                                            </div>
                                        </label>

                                        <div class="field-files-wrapper">
                                            <div class="field-files-list"
                                                 v-if="videos.length !== 0">
                                                <div class="field-file">
                                                    <span class="filename">{{ getFileName(videos[0].name) }}</span>
                                                    <button @click="delFile(videos[0], 'video')" class="button-del-file"
                                                            title="Удалить файл">
                                                        <DeleteIcon/>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="field-file loading-file" v-show="loadingVideo">
                                                <div class="loading-progress">
                                                    <div class="loading-progress-bar" style="width: 42%"></div>
                                                    <div class="loading-percent">{{ uploadVideoPercentage }}%</div>
                                                </div>
                                                <button @click="cancelRequest" class="button-del-file"
                                                        title="Отменить загрузку">
                                                    <DeleteIcon/>
                                                </button>
                                            </div>

                                            <div v-show="videos.length === 0" class="add-file-button"
                                                 @click="loadVideo">
                                                <button class="button-nobg-icon add-other-doc">
                                                    <span class="icon"><PlusIcon/></span>
                                                    <span class="text">Добавить видео</span>
                                                </button>
                                                <input type="file" accept="video/*"
                                                       class="dev_video_input dev_file_input"
                                                       @change="addVideo($event)">
                                            </div>

                                            <div class="msg-form">
                                                Можно добавить только один видеофайл длительностью не более 10-ти минут
                                            </div>
                                        </div>
                                    </div>
                                </section>


                                <div class="form-field-input-2">
                                    <label>Отправка писем контактным лицам</label>
                                    <div class="field-input-wrapper form-field-radio">
                                        <label>
                                            <span class="field-radio-wrapper">
                                                <input type="radio" class="" checked name="send-contacts" value="true" v-model="agreement">
                                                <span class="field-radio"></span>
                                            </span>
                                            <span>Отправлять письмо контактным лицам, если по тем или иным причинам его не удалось отправить адресатам</span>
                                        </label>

                                        <label>
                                            <span class="field-radio-wrapper">
                                                <input type="radio" class="" name="send-contacts" value="false" v-model="agreement">
                                                <span class="field-radio"></span>
                                            </span>
                                            <span>Не отправлять письмо контактным лицам, если по тем или иным причинам его не удалось отправить адресатам</span>
                                        </label>
                                    </div>
                                </div>


                                <div v-if="newMail" class="button-block button-block-other">
                                    <div class="button-wrapper">

                                    </div>
                                    <div class="button-wrapper">
                                        <button @click="submitMail" class="button button-dark"
                                                :disabled="!isAllFieldsFilled || phoneError">Оформить подписку
                                        </button>
                                    </div>
                                    <div class="button-wrapper">
                                        <button @click="submitDraft" class="button button-not-important">Сохранить
                                            черновик
                                        </button>
                                    </div>
                                </div>

                                <div v-if="!newMail && subscribed" class="button-block button-block-other">
                                    <DeleteSubscribedMailWindow @confirmDelete="confirmDelete"/>
                                    <CancelSubscribeWindow @confirmCancel="confirmCancel"/>
                                    <div class="button-wrapper">
                                        <button @click="cancelSubscription"
                                                :disabled="canceling"
                                                class="button button-not-important modal-subscribe-cancel">Отменить подписку
                                        </button>
                                    </div>
                                    <div class="button-wrapper">
                                        <button @click="saveMail" class="button button-border"
                                                :class="{'button-load': loading}"
                                                :disabled="!isAllFieldsFilled || loading || canceling || phoneError">
                                            <div v-if="loading" class="spinner-load"><div v-if="loading" class="spinner"></div></div>Сохранить письмо
                                        </button>
                                    </div>
                                    <div class="button-wrapper">
                                        <button @click="deleteMail" class="button button-important mail-delete">Удалить
                                            письмо
                                        </button>
                                    </div>
                                </div>

                                <div v-if="!newMail && !subscribed" class="button-block button-block-other">
                                    <DeleteDraftWindow @confirmDelete="confirmDelete"/>

                                    <div class="button-wrapper">
                                        <button @click="submitDraft" class="button button-not-important">Сохранить
                                            черновик
                                        </button>
                                    </div>
                                    <div class="button-wrapper">
                                        <button @click="submitMail" class="button button-dark modal-subscribe-next"
                                                :disabled="!isAllFieldsFilled || phoneError">Оформить подписку
                                        </button>
                                    </div>
                                    <div class="button-wrapper">
                                        <button @click="deleteDraft" class="button button-important draft-delete">
                                            Удалить черновик
                                        </button>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>

        <FooterAuth/>
    </div>


</template>


<script>
import FooterAuth from "../components/FooterAuth";
import HeaderAuth from "../components/HeaderAuth";
import ClientNavigation from "../components/ClientNavigation";
import HelpIcon from "../components/icons/HelpIcon";
import DeleteIcon from "../components/icons/DeleteIcon";
import PlusIcon from "../components/icons/PlusIcon";
import VueTagsInput from '@johmun/vue-tags-input';
import {quillEditor} from 'vue-quill-editor'
import InvalidFileFormatWindow from '../components/windows/InvalidFileFormatWindow.vue';
import ContactNoSaveWindow from '../components/windows/ContactNoSaveWindow.vue';
import axios from 'axios';
import store from '@/store';
import router from "../router"
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import * as lang from "vuejs-datepicker/src/locale";
import rest from "../restUtils";
import CloseIcon from "../components/icons/CloseIcon.vue";
import BackIcon from "../components/icons/BackIcon";
import SubscriptionSuccess from "../components/blocks/SubscriptionSuccess";
import SubscriptionError from "../components/blocks/SubscriptionError";
import DeleteSubscribedMailWindow from "../components/windows/DeleteSubscribedMailWindow";
import CancelSubscribeWindow from "../components/windows/CancelSubscribeWindow";
import DeleteDraftWindow from "../components/windows/DeleteDraftWindow";
import SaveWindow from "@/components/windows/SaveWindow";
import FileSizeErrorWindow from "@/components/windows/FileSizeErrorWindow";
import VideoLengthErrorWindow from "@/components/windows/VideoLengthErrorWindow";
import FileLoadErrorWindow from "@/components/windows/FileLoadErrorWindow";

const videoExt = ['mp4', 'mpeg4', 'mov', 'avi', 'flv', '3gp', 'wmv'];
const imgExt = ['jpg', 'png', 'jpeg'];
const docExt = ['pdf', 'docx'];

const appUrl = process.env.VUE_APP_GLOBAL_URL;
const cancelToken = axios.CancelToken;
let source = cancelToken.source();
const MAX_SOCIALS_SIZE = 120;
const MAX_FILE_SIZE = 10 * 1024 * 1024;
const MAX_VIDEO_SIZE = 150 * 1024 * 1024;

export default {
    name: 'MailCreate',
    components: {
        FileLoadErrorWindow,
        VideoLengthErrorWindow,
        FileSizeErrorWindow,
        SaveWindow,
        DeleteDraftWindow,
        CancelSubscribeWindow,
        DeleteSubscribedMailWindow,
        SubscriptionError,
        SubscriptionSuccess,
        BackIcon,
        CloseIcon,
        PlusIcon,
        DeleteIcon,
        HelpIcon,
        ClientNavigation,
        HeaderAuth,
        FooterAuth,
        VueTagsInput,
        quillEditor,
        InvalidFileFormatWindow,
        ContactNoSaveWindow,
        Datepicker
    },
    metaInfo: {
        title: 'Новое письмо | Your Last Word'
    },

    watch: {
        '$route.query.id': function () {
            if (!this.$route.query.id) {
                this.id = 0;
                this.email = '';
                this.emails = [];
                this.emailIncorrect = false;
                this.social = '';
                this.socials = [];
                this.subject = '';
                this.content = '';
                this.documents = [];
                this.images = [];
                this.imagesSrc = [];
                this.currentTypes = [];
                this.loadingDoc = false;
                this.loadingImg = false;
                this.uploadDocPercentage = 0;
                this.uploadImgPercentage = 0;
                this.isChanged = false;
                this.quillFirstChange = false;
                this.sendDate = '';
                this.agreement = true;
                this.subscribed = false;
                this.newMail = true;
                this.videos = [];
                this.receiverPhone = '';
            } else {
                this.newMail = false;
            }
        },
        email: function () {
            this.emailIncorrect = false;
        }
    },

    data() {
        return {
            id: 0,
            email: '',
            emails: [],
            emailIncorrect: false,
            social: '',
            socials: [],
            subject: '',
            content: '',
            options: {
                modules: {
                    toolbar: [
                        [{'header': 1}, 'bold', 'italic', 'underline', 'strike'],
                        [{'align': []}],
                        ['blockquote'],
                        [{'list': 'ordered'}, {'list': 'bullet'}],
                        [{'color': []}, {'background': []}],
                        ['link'],
                        ['clean'],
                    ]
                },
                theme: 'snow',
                placeholder: ''
            },
            documents: [],
            images: [],
            imagesSrc: [],
            currentTypes: [],
            loadingDoc: false,
            loadingImg: false,
            loadingVideo: false,
            uploadDocPercentage: 0,
            uploadImgPercentage: 0,
            uploadVideoPercentage: 0,
            isChanged: false,
            quillFirstChange: false,
            sendDate: '',
            language: "ru",
            languages: lang,
            agreement: true,
            disabledDates: {
                to: new Date()
            },
            subscribed: false,
            newMail: true,
            videos: [],
            locked: false,
            maxTags: 1,
            maxLength: MAX_SOCIALS_SIZE,
            validateCompleted: false,
            validated: false,
            fileSize: 0,
            loading: false,
            canceling: false,
            phoneError: false,
            intlTelNumber: {},
            intlTelCountry: {},
            defaultCountry: 'RU',
            receiverPhone: ''
        };
    },



    mounted() {

        if( $('li').is('.ti-tag') ) {

            $('.ti-icon-close').on({
                mouseenter: function () {
                    $(this).closest('.ti-tag').addClass('hovered');
                },
                mouseleave: function () {
                    $(this).closest('.ti-tag').removeClass('hovered');
                }
            });
        }
    },

    async created() {
        if (this.$route.query.id) {
            this.locked = true;
            let mail = await rest.doGet('/mail/' + this.$route.query.id);
            this.locked = false;
            if (mail !== "") {
                this.id = mail.id;
                this.emails = mail.recepientList.trim() !== '' ? mail.recepientList.trim().split(',').map(em => {
                    return {text: em}
                }) : [];
                this.socials = mail.socialList.trim() !== '' ? mail.socialList.trim().split(',').map(sc => {
                    return {text: sc}
                }) : [];
                this.subject = mail.topic;
                this.content = mail.text;
                this.subscribed = mail.subscribed;
                this.quillFirstChange = true;
                this.documents = this.getFilesByType(mail.attachmentList, 'doc');
                this.images = this.getFilesByType(mail.attachmentList, 'img');
                this.images.forEach(img => {
                    this.imagesSrc.push(this.getFilePath(img));
                });
                this.videos = this.getFilesByType(mail.attachmentList, 'video');
                this.sendDate = mail.sendDate;
                this.agreement = mail.agreement;
                this.newMail = false;

                let socialsText = this.socials.map(social => social.text);
                let length = socialsText.join("").length;
                this.maxLength = MAX_SOCIALS_SIZE - length;
                this.maxTags = this.socials.length;
                if (this.maxLength > 0) {
                    this.maxTags++;
                }
                this.receiverPhone = mail.receiverPhone === null ? '' : mail.receiverPhone;
            } else {
                router.push({path: '/mail'});
            }
        }
    },

    updated() {
        $('.ti-icon-close').on({
            mouseenter: function () {
                $(this).closest('.ti-tag').addClass('hovered');
            },
            mouseleave: function () {
                $(this).closest('.ti-tag').removeClass('hovered');
            }
        });
    },

    computed: {
        isAllFieldsFilled() {
            return this.emails.length > 0 && this.subject !== '';
        },
        getPlaceholder() {
            return this.emails.length > 0 ? '' : 'Введите email';
        }
    },

    methods: {
        checkEmail(obj) {
            let reg = new RegExp("^([a-z0-9_-]+\\.)*[a-z0-9_-]+@[a-z0-9_-]+(\\.[a-z0-9_-]+)*\\.[a-z]{2,6}$");
            if (!reg.test(obj.tag.text)) {
                this.emailIncorrect = true;
            } else {
                this.emailIncorrect = false;
                obj.addTag();
            }
        },
        loadDoc() {
            if (this.documents.length < 5 && !this.canceling && !this.loading) {
                $('.dev_doc_input').click();
            }
        },
        addDoc(event) {
            let files = Object.assign({}, event.target.files);
            let length = event.target.files.length;
            let error = false;

            for (let i = 0; i < length; i++) {
                if (i > 4) {
                    error = true;
                    break;
                }

                let file = files[i];
                if (file.type !== 'application/pdf' && file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
                    error = true;
                } else {
                    if (file.size > MAX_FILE_SIZE) {
                        error = true;
                    } else {
                        this.uploadFile(file, 'doc');
                        this.documents.push(file);
                    }
                }
            }

            $('.dev_file_input').val('');
            if (error) {
                $('.window-wrapper.window-file-load-error').addClass('window-open');
                $('body').addClass('blocked');
            }
        },
        loadImg() {
            if (this.images.length < 5 && !this.canceling && !this.loading) {
                $('.dev_img_input').click();
            }
        },
        addImg(event) {
            let files = Object.assign({}, event.target.files);
            let length = event.target.files.length;
            let error = false;
            for (let i = 0; i < length; i++) {
                if (i > 4) {
                    error = true;
                    break;
                }

                let file = files[i];
                if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
                    error = true;
                } else {
                    if (file.size > MAX_FILE_SIZE) {
                        error = true;
                    } else {
                        this.uploadFile(file, 'img');
                        this.images.push(file);
                        let reader = new FileReader();
                        reader.onload = this.onImageLoad;
                        reader.readAsDataURL(file);
                    }
                }
            }
            $('.dev_file_input').val('');
            if (error) {
                $('.window-wrapper.window-file-load-error').addClass('window-open');
                $('body').addClass('blocked');
            }
        },
        loadVideo() {
            if (this.videos.length === 0 && !this.canceling && !this.loading) {
                $('.dev_video_input').click();
            }
        },
        async addVideo(event) {
            let file = event.target.files[0];
            $('.dev_file_input').val('');
            if (!file.type.startsWith("video/")) {
                this.currentTypes = videoExt;
                $('.window-mail-no-format').addClass('window-open');
            } else {
                if (file.type !== 'video/mp4' && file.type !== 'video/mov'&& file.type !== 'video/quicktime') {
                    if (file.size > MAX_VIDEO_SIZE) {
                        $('.window-wrapper.window-video-length-error').addClass('window-open');
                        $('body').addClass('blocked');
                    } else {
                        this.uploadFile(file, 'video');
                        this.videos.push(file);
                    }
                } else {
                    this.validateVideo(file);
                }
            }
        },
        getFilePath(img) {
            if (img.scaledFilename !== null) {
                return appUrl + '/files' + img.scaledFilename;
            }
            return appUrl + '/files' + img.fullname;
        },
        getFileName(name) {
            let ext = name.substring(name.lastIndexOf('.') + 1);
            let fileName = name.substring(0, name.lastIndexOf('.'));
            return fileName.length > 9 ? fileName.substr(0, 9) + '...' + ext : fileName + '.' + ext;
        },
        onImageLoad(e) {
            this.imagesSrc.push(e.target.result);
        },
        uploadFile(file, type) {
            this.isChanged = true;
            $('.dev_file_input').val('');

            if (type === 'doc') {
                this.loadingDoc = true;
            } else if (type === 'img') {
                this.loadingImg = true;
            } else if (type === 'video') {
                this.loadingVideo = true;
            }

            let formData = new FormData();
            formData.append('file', file);
            const url = process.env.VUE_APP_GLOBAL_URL + '/files';
            let headers = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: function (progressEvent) {
                    let uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                    if (type === 'doc') {
                        this.uploadDocPercentage = uploadPercentage;
                    } else if (type === 'img') {
                        this.uploadImgPercentage = uploadPercentage;
                    } else if (type === 'video') {
                        this.uploadVideoPercentage = uploadPercentage;
                    }
                }.bind(this),
                cancelToken: source.token
            };

            let token = store.getters.token;
            if (token)
                Object.assign(headers.headers, {Authorization: token});

            axios.post(url, formData, headers).then(result => {
                let uploadedFile = result.data;
                uploadedFile.type = file.type;
                if (type === 'doc') {
                    this.uploadDocPercentage = 0;
                    this.loadingDoc = false;
                    let index = this.documents.indexOf(file);
                    this.documents.splice(index, 1, uploadedFile);
                } else if (type === 'img') {
                    this.uploadImgPercentage = 0;
                    this.loadingImg = false;
                    let index = this.images.indexOf(file);
                    this.images.splice(index, 1, uploadedFile);
                } else if (type === 'video') {
                    this.uploadVideoPercentage = 0;
                    this.loadingVideo = false;
                    this.videos[0] = uploadedFile;
                }
            }).catch(thrown => {
                if (type === 'doc') {
                    this.uploadDocPercentage = 0;
                    this.loadingDoc = false;
                    let index = this.documents.indexOf(file);
                    this.documents.splice(index, 1);
                } else if (type === 'img') {
                    this.uploadImgPercentage = 0;
                    this.loadingImg = false;
                    let index = this.images.indexOf(file);
                    this.images.splice(index, 1);
                    this.imagesSrc.splice(index, 1);
                } else if (type === 'video') {
                    this.uploadVideoPercentage = 0;
                    this.loadingVideo = false;
                    this.videos = [];
                }
            })
        },
        validateVideo(file) {
            var video = document.createElement('video');
            video.preload = 'metadata';

            let that = this;
            video.onloadedmetadata = function() {

                window.URL.revokeObjectURL(video.src);

                if (video.duration > 10 * 60 + 1) {

                    $('.window-wrapper.window-video-length-error').addClass('window-open');
                    $('body').addClass('blocked');
                    return;
                }

                that.uploadFile(file, 'video');
                that.videos.push(file);
            }

            video.src = URL.createObjectURL(file);
        },
        cancelRequest() {
            source.cancel("");
            source = cancelToken.source();
        },
        confirmNext() {
            this.next();
        },
        delFile(file, type) {
            if (type === 'doc') {
                let index = this.documents.indexOf(file);
                this.documents.splice(index, 1);
            } else if (type === 'img') {
                let index = this.images.indexOf(file);
                this.images.splice(index, 1);
                this.imagesSrc.splice(index, 1);
            } else if (type === 'video') {
                this.videos = []
            }
            this.isChanged = true;
        },
        async submitMail() {
            if (!$.isEmptyObject(this.intlTelNumber) && !this.intlTelNumber.isValid && this.receiverPhone.length > 0) {
                this.phoneError = true;
                return;
            }

            let mailDto = {
                id: this.id,
                topic: this.subject,
                text: this.content,
                recepientList: this.emails.map(em => em.text).join(','),
                socialList: this.socials.map(em => em.text).join(','),
                attachmentList: this.documents.concat(this.images).concat(this.videos),
                sendDate: this.sendDate,
                agreement: this.agreement,
                receiverPhone: this.intlTelNumber.number.international
            };

            try {
                let result = await rest.doPost('/mail', mailDto);
                this.id = result;
                this.isChanged = false;
                router.push({path: '/subscribe', query: {id: result}});
            } catch (error) {
            }
        },
        async submitDraft() {
            if (!$.isEmptyObject(this.intlTelNumber) && !this.intlTelNumber.isValid && this.receiverPhone.length > 0) {
                this.phoneError = true;
                return;
            }

            let mailDto = {
                id: this.id,
                topic: this.subject,
                text: this.content,
                recepientList: this.emails.map(em => em.text).join(','),
                socialList: this.socials.map(em => em.text).join(','),
                attachmentList: this.documents.concat(this.images).concat(this.videos),
                sendDate: this.sendDate,
                agreement: this.agreement,
                receiverPhone: this.intlTelNumber.number.international
            };

            try {
                this.id = await rest.doPost('/mail', mailDto);
                this.isChanged = false;
                router.replace("/mail?id=" + this.id);

                $('.window-wrapper.window-save-contacts').addClass('window-open');
                $('body').addClass('blocked');
            } catch (error) {

            }
        },
        getFilesByType(files, type) {
            let result = [];
            files.forEach(file => {
                let ext = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
                if (type === 'doc' && (docExt.indexOf(ext) > -1)) {
                    result.push(file);
                } else if (type === 'img' && (imgExt.indexOf(ext) > -1)) {
                    result.push(file);
                } else if (type === 'video' && file.type === 'video') {
                    result.push(file);
                }
            });
            return result;
        },
        quillChange() {
            this.isChanged = !this.quillFirstChange;
            this.quillFirstChange = false;
        },
        deleteMail() {
            $('.window-wrapper.window-mail-delete').addClass('window-open');
            $('body').addClass('blocked');
        },
        async confirmDelete() {
            await rest.doDelete('/mail/' + this.id);
            router.push('/mails');
        },
        deleteDraft() {
            $('.window-wrapper.window-mail-draft-delete').addClass('window-open');
            $('body').addClass('blocked');
        },
        cancelSubscription() {
            $('.window-wrapper.window-mail-subscribe-cancel').addClass('window-open');
            $('body').addClass('blocked');
        },
        async confirmCancel() {
            try {
                this.canceling = true;
                await rest.doPut('/mail/cancel-subscription/' + this.id);
                this.canceling = false;
                this.subscribed = false;
            } catch (e) {

            }
        },
        async saveMail() {
            if (!$.isEmptyObject(this.intlTelNumber) && !this.intlTelNumber.isValid && this.receiverPhone.length > 0) {
                this.phoneError = true;
                return;
            }

            this.loading = true;
            let mailDto = {
                id: this.id,
                topic: this.subject,
                text: this.content,
                recepientList: this.emails.map(em => em.text).join(','),
                socialList: this.socials.map(em => em.text).join(','),
                attachmentList: this.documents.concat(this.images).concat(this.videos),
                sendDate: this.sendDate,
                agreement: this.agreement,
                receiverPhone: this.intlTelNumber.number.international
            };

            try {
                this.id = await rest.doPost('/mail', mailDto);
                this.isChanged = false;
                this.loading = false;
                $('.window-wrapper.window-save-contacts').addClass('window-open');
                $('body').addClass('blocked');
            } catch (error) {
                this.loading = false;
            }
        },
        subscribe() {
            router.push({path: '/subscribe', query: {id: this.id}});
        },
        addDuplicateEmail(o) {
            let duplicate = {text: o.text, classes: 'dev_invalid'};
            this.emails.push(duplicate);
            this.email = '';
            let thatEmails = this.emails;
            setTimeout(function () {
                let index = thatEmails.indexOf(duplicate);
                thatEmails.splice(index, 1);
            }, 500);
        },
        addDuplicateSocial(o) {
            let duplicate = {text: o.text, classes: 'dev_invalid'};
            this.socials.push(duplicate);
            this.social = '';
            let thatSocials = this.socials;
            setTimeout(function () {
                let index = thatSocials.indexOf(duplicate);
                thatSocials.splice(index, 1);
            }, 500);
        },
        socialInput(newTags) {
            this.socials = newTags;
            this.isChanged = true;
            let socialsText = this.socials.map(social => social.text);
            let length = socialsText.join("").length;
            this.maxLength = MAX_SOCIALS_SIZE - length;
            this.maxTags = this.socials.length;
            if (this.maxLength > 0) {
                this.maxTags++;
            }
        },
        datepickerClear() {
            this.isChanged = true;
            this.sendDate = '';
        },

        phoneInput(number, tel) {
            this.isChanged = true;
            this.phoneError = false;
            this.intlTelNumber = {number: tel.number, isValid: tel.isValid};

            if (tel.number.international) {
                let index = tel.number.international.indexOf(" ");
                this.receiverPhone = tel.number.international.slice(index + 1);
            }

        },
        countryChanged(country) {
            this.intlTelCountry = country;
            this.defaultCountry = country.iso2;
            this.$refs.phoneNumber.choose(this.defaultCountry);

            if (this.receiverPhone && this.receiverPhone.includes("+")) {
                this.receiverPhone = this.receiverPhone.replace("+".concat(country.dialCode), "");
            }
        },
        phoneValidate(tel) {
            this.intlTelNumber = {number: tel.number, isValid: tel.isValid};
            if (tel.isValid) {
                this.defaultCountry = tel.regionCode;
                this.$refs.phoneNumber.choose(tel.regionCode);
            }

            if (tel.number.international) {
                let index = tel.number.international.indexOf(" ");
                this.receiverPhone = tel.number.international.slice(index + 1);
            }
        },
    },

    beforeCreate() {
        $('body').attr('class', 'cabinet-page mail-page');
    },

    beforeRouteLeave(to, from, next) {
        if (this.isChanged) {
            $('.window-wrapper.window-no-save-contacts').addClass('window-open');
            $('body').addClass('blocked');
            this.next = next;
        } else {
            next();
        }
    },

}
</script>

<style>
.dev_tag_error .ti-input {
    border-color: #dd5656;
    color: #dd5656;
}

.vue-tags-input {
    max-width: 1000px !important;
}
.ti-input{
    padding: 7.2px 16px !important;
}

.dev_invalid {
    background-color: #e54d42 !important;
}

.ti-tags {
    line-height: initial !important;
}

.ti-tag {
    color: black !important;
    font-size: inherit !important;
    cursor: default;

}

ul.ti-tags li.ti-tag.ti-valid:not(.hovered):hover {
    background-color: #D3E2E2 !important;
}

.ti-tag .ti-actions i[data-v-61d92e31] {
    border-radius: 50px;
    font: 10px/1 Arial;
}

.ti-tag.ti-tag.ti-deletion-mark, ul li.ti-tag.hovered,.ti-invalid {
    color: rgba(0, 0, 0, 0.7) !important;
    background-color: rgba(211, 148, 148, 0.3) !important;
    cursor: default;
}

ul li.ti-tag.hovered .ti-icon-close {
    background-color: #c77777 !important;
}

.field-help-wrapper:hover .field-help-text {
    display: block;
}

.quill-editor {
    height: 150px;
}

.ql-container {
    height: 140px !important;
}

@media (max-width: 575.98px) {
    .ql-container {
        height: 100px !important;
    }
}

</style>